import { useEffect } from 'react';

import { geographicalRestrictionsStubConfig } from '@shared/configs/stub.config';
import { AnalyticsEventEnum } from '@shared/enums/analyticsEvent.enum';
import useAnalyticsEventTracker from '@shared/hooks/analytics/useAnalyticsEventTracker';
import { Stub } from 'shared/ui-kit';

import { StubContainer } from './GeographicalRestrictionsStub.style';

const support_link = 'support@hubmee.com';
export const GeographicalRestrictionsStub = () => {
  const gaEventTracker = useAnalyticsEventTracker();

  const handleClick = () => {
    const location = `mailto:${support_link}`;

    const newTab = window.open(location, '_self');
    newTab!.opener = null;
  };

  useEffect(() => {
    gaEventTracker({
      event: AnalyticsEventEnum.geographicalRestrictionsStubShowed,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <StubContainer>
      <Stub
        config={geographicalRestrictionsStubConfig}
        buttonProps={{
          label: 'Contact support',
          onClick: handleClick,
        }}
      />
    </StubContainer>
  );
};
